var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 1.5A1.5 1.5 0 0 1 3.5 0h19A1.5 1.5 0 0 1 24 1.5V4h-2V2H4v22h2v2H3.5A1.5 1.5 0 0 1 2 24.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 7.5A1.5 1.5 0 0 1 9.5 6H21a1 1 0 0 1 .707.293l8 8A1 1 0 0 1 30 15v15.5a1.5 1.5 0 0 1-1.5 1.5h-19A1.5 1.5 0 0 1 8 30.5zm2 .5v22h18V16h-6.5a1.5 1.5 0 0 1-1.5-1.5V8zm12 1.414L26.586 14H22z",
  clipRule: "evenodd"
})));
export default SvgCopy;